import * as React from 'react'

import { Box, BoxList, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ArchiveItem from 'modules/locations/components/ArchivedItem'
import { WorkAreaNodes } from 'modules/locations/hooks/useWorkArea'

interface Props {
  workArea: WorkAreaNodes
  unarchiveWorkArea: (workArea: WorkAreaNodes) => void
}

const ArchivedWorkAreaItem = ({ workArea, unarchiveWorkArea }: Props) => {
  return (
    <BoxList.Item>
      <Box width="full">
        <ArchiveItem name={workArea!.name}>
          <Button
            onClick={() => unarchiveWorkArea(workArea)}
            type="secondary"
            iconName="archive-open"
          />
        </ArchiveItem>
      </Box>
    </BoxList.Item>
  )
}

export default observer(ArchivedWorkAreaItem)
